import apiClient from './client'

export interface DashboardSummary {
  total_users: number
  active_users: number
  inactive_users: number
  total_companies: number
  active_companies: number
  inactive_companies: number
  total_groups: number
  total_sessions: number
  active_sessions: number
  inactive_sessions: number
  recent_users: Array<{
    id: number
    name: string
    email: string
    is_active: boolean
    nivel_acesso?: number | null
    created_at?: string | null
  }>
  recent_sessions: Array<{
    id: number
    user_id: number
    user_email: string
    created_at?: string | null
    valid: boolean
  }>
}

export interface ContainerStat {
  id: string
  image: string
  status: string
  state: string
  ports: string
  names: string
  cpu_perc: string
  mem_usage_limit: string
  mem_perc: string
  net_io: string
  block_io: string
  pids: string
}

export interface ContainersResponse {
  online: boolean
  error?: string
  containers: ContainerStat[]
}

export const dashboardApi = {
  getSummary: async (): Promise<DashboardSummary> => {
    const response = await apiClient.get<DashboardSummary>('/dashboard/summary', {
      timeout: 10000, // 10 segundos de timeout
    })
    return response.data
  },

  getContainers: async (): Promise<ContainersResponse> => {
    const response = await apiClient.get<ContainersResponse>('/dashboard/containers', {
      timeout: 10000, // 10 segundos de timeout
    })
    return response.data
  },
}

